// extracted by mini-css-extract-plugin
export default {"card":"statisticcard_card__md4jA","heading":"statisticcard_heading__JswEO","content":"statisticcard_content__J80Dd","infoIcon":"statisticcard_infoIcon__7Pf1C"};